import { Avatar, Typography } from "@/components/atoms";
import { useClientScope } from "@/components/pages/Client/settings/ClientScopeContext";
import { useGetClientProfileQuery } from "@/redux/apis/clientProfile/clientProfileApi";
import { getInitials } from "@/utils";

/**
 * Client avatar + name card at the top of the Booking Summary rail (Figma 11220-125891).
 * Rendered only under operator OBO scope — self-service returns null, leaving the summary
 * unchanged. The endpoint has no photo, so the Avatar shows initials.
 */
export const ScopedClientCard = () => {
  const { accountId } = useClientScope();
  const { data: profile } = useGetClientProfileQuery(accountId ? { accountId } : undefined, { skip: !accountId });

  if (!accountId) return null;

  const name = [profile?.personal.first_name, profile?.personal.last_name].filter(Boolean).join(" ");

  return (
    <div className="mb-2 flex items-center gap-3 rounded-lg border border-neutral-mid-gray bg-white p-3">
      <Avatar size="md" alt={name} className="bg-neutral-mid-gray">
        <Typography variant="action" className="text-neutral-dark-gray">
          {name ? getInitials(name) : ""}
        </Typography>
      </Avatar>
      <Typography variant="title" className="min-w-0 truncate">
        {name}
      </Typography>
    </div>
  );
};
